/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Overlay from 'ol/Overlay';
import InDevelopmentBanner from '../utility/InDevelopmentBanner';
import Show from '../utility/Show';
import { createMap } from '../../utils/map/mapHelpers';
import { setRefs } from '../../utils/map/popup';

const useStyles = ({ rounded }) => ({
  map: {
    width: '100%',
    height: '100%',
    borderRadius: rounded ? '5px' : 'inherit',
    overflow: rounded ? 'hidden' : 'inherit',
    backgroundColor: 'white',
  },
  popup: {
    position: 'absolute',
    backgroundColor: 'white',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid #cccccc',
    bottom: '12px',
    left: '-50px',
    minWidth: '280px',
  },
  popupContent: {
    color: 'black',
  },
  popupCloser: {
    textDecoration: 'none',
    position: 'absolute',
    top: '2px',
    right: '8px',
    color: 'red',
  },
});

const OpenLayersMap = ({ rounded }) => {
  const cacheVersion = useSelector(({ cacheVersion }) => cacheVersion);
  const currentUser = useSelector(({ currentUser }) => currentUser);
  const styles = useStyles({ rounded });
  const ref = useRef();
  const closerRef = useRef();
  const contentRef = useRef();
  const containerRef = useRef();
  const [mapRef, setMapRef] = useState(null);

  useEffect(() => {
    if (mapRef && closerRef && contentRef) {
      const container = containerRef.current;
      const content = contentRef.current;
      const closer = closerRef.current;

      const overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });
      mapRef.addOverlay(overlay);
      if (closer) {
        closer.onclick = () => {
          overlay.setPosition(undefined);
          closer.blur();
          return false;
        };
      }

      setRefs({ overlay, content });
    }
  }, [mapRef, contentRef, closerRef]);

  useEffect(() => {
    if (cacheVersion) {
      const map = createMap({ div: ref.current, currentUser });
      setMapRef(map);
      // reset map target if not being shown
      return () => map.setTarget();
    }
  }, [cacheVersion, currentUser]);

  return (
    <div id="ol-map" ref={ref} style={styles.map}>
      <div id="popup" ref={containerRef} style={styles.popup}>
        <a href="#" id="popup-closer" ref={closerRef} style={styles.popupCloser}>x</a>
        <div style={styles.popupContent} id="popup-content" ref={contentRef} />
      </div>
      {/* if not in production, show "PRELIMINARY DATA" message */}
      <Show test={process.env.REACT_APP_SHOW_DEV_BANNER}>
        <InDevelopmentBanner parentRef={ref} />
      </Show>
    </div>
  );
};

export default OpenLayersMap;
